import Blocker from 'components/shared/Blocker';
import { ActiveLanguage } from 'shared/vidio_helpers';
import Tracker from './Tracker';

export default class LivestreamingEndedBanner {
  constructor() {
    this._container = document.querySelector('.livestreaming-ended-banner');
  }

  activeLanguage() {
    return ActiveLanguage.get();
  }

  locale() {
    return window.Locale[this.activeLanguage()].livestreaming_ended_banner;
  }

  shouldInit() {
    return !!this._container;
  }

  init() {
    const title = this.locale().title;
    const description = this.locale().description;

    this._blocker = new Blocker({
      element: this._container,
      title: title,
      subtitle: description
    });
  }

  show() {
    this._container.classList.remove('hide');
    this._blocker.show();
    Tracker.sendEndedEvent();
    window.player.dispose();
  }
}
